import { render, staticRenderFns } from "./global-footer.vue?vue&type=template&id=7d896148&"
import script from "./global-footer.vue?vue&type=script&lang=js&"
export * from "./global-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports